import { Box, Modal } from "@mui/material";
import React from "react";

function UspContentModal({ uspModalOpen, setUspModalOpen, uspModalContent, designNo }) {
  return (
    <Modal open={uspModalOpen} onClose={() => setUspModalOpen(false)}>
      <Box
        sx={{
          width: "400px",
          height: "282px",
          bgcolor: "#fff",
          border: "none !important",
          outline: "none !important",
          borderRadius: "5px",
          padding: "20px",
          position: "fixed",
          right: "20px",
          bottom: "20px",
          wordBreak: "break-word",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          color: "#000000",
          fontFamily: "Karla",
        }}
      >
        <div style={{ fontWeight: 500, fontSize: "24px", lineHeight: "22px", letterSpacing: "-0.41px" }}>{designNo}</div>
        <div
          style={{
            width: "360px",
            height: "200px",
            border: "0.5px solid #000",
            borderRadius: "5px",
            padding: "10px",
            boxSizing: "border-box",
            fontSize: "16px",
            fontFamily: "Poppins",
            fontWeight: 400,
            overflow: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#999 transparent",
          }}
        >
          {uspModalContent}
        </div>
      </Box>
    </Modal>
  );
}

export default UspContentModal;
